import { IonContent, IonPage, NavContext } from '@ionic/react';
import { useContext, useEffect } from 'react';

import { getClinicIdByShareCode } from '@/data/Shares';
import { LEGACY_ROUTES, ROUTES, getScheduleRoute } from '@/utils/routes';
import { useParams } from 'react-router';

const Share: React.FC = () => {
  const { navigate } = useContext(NavContext);
  const { id: code } = useParams<{ id: string }>();

  useEffect(() => {
    const navigateFromCode = async () => {
      if (!code) {
        navigate(ROUTES.INVALID);
        return;
      }

      const legacyEntry = Object.entries(LEGACY_ROUTES).find(
        ([, path]) => path === `/${code}`
      );

      if (legacyEntry) {
        const [routeKey] = legacyEntry;
        navigate(ROUTES[routeKey]);
        return;
      }

      try {
        const clinicId = await getClinicIdByShareCode(code);
        if (clinicId) {
          navigate(getScheduleRoute(clinicId));
          return;
        }
        navigate(ROUTES.INVALID);
      } catch {
        navigate(getScheduleRoute(code));
      }
    };

    void navigateFromCode();
  }, [code, navigate]);

  return (
    <IonPage id="share">
      <IonContent>
        {/* 
          Note: Display a blank page to avoid jumpy behavior when redirecting to schedule page
          Uncomment the following to show loading indicator:
          <Padding>
            <Logo />
            <Loading />
          </Padding>
        */}
      </IonContent>
    </IonPage>
  );
};

export default Share;
